'use client';

import { Stack, Title } from '@mantine/core';
import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense, useCallback, useEffect } from 'react';

import { ColumnarLayout, LoadingState, LoginForm } from '@/components';
import { useAuth } from '@/hooks';

function LoginPageContent() {
  const searchParams = useSearchParams();
  const returnUrl = searchParams.get('returnUrl') || '%2Fme';
  const router = useRouter();
  const { isLoggedIn, isLoading } = useAuth();

  const onLoggedIn = useCallback(() => {
    router.push(decodeURIComponent(returnUrl));
  }, [router, returnUrl]);

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      router.replace('/me');
    }
  }, [isLoggedIn, isLoading, router]);

  return (
    <ColumnarLayout
      columnStartIsHiddenOnMobile
      columnStart={
        <Stack>
          <Title order={1}>Welcome to Sway</Title>
          <Title order={2}>Connect. Influence. Transform.</Title>
        </Stack>
      }
      columnEnd={<LoginForm onLoggedIn={onLoggedIn} />}
    />
  );
}

export default function LoginPage() {
  return (
    <Suspense
      fallback={
        <LoadingState
          message="Loading..."
          engagingMessages={[
            'Finding your personal information...',
            'Getting things ready for you...',
            'Almost there...',
          ]}
        />
      }
    >
      <LoginPageContent />
    </Suspense>
  );
}
